import { useRef } from "react";

const SubEventsList = ({ 
  visibleSubEvents, 
  onSelectEvent, 
  isOpen, 
  position
}) => {
  const listRef = useRef(null);

  if (!isOpen || visibleSubEvents.length === 0) return null;

  return (
    <div 
      ref={listRef}
      className="sub-events-list-container"
    >
      <div className="sub-events-list">
        {visibleSubEvents.map((event) => (
          <div
            key={event} 
            className="sub-event-item"
            onClick={() => {
              onSelectEvent(event);
            }}
          >
            {event}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubEventsList;
